import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceJobAdder = (props) => {

    const ClientId = "6uwspgn5fruudckdd3hg76eyiq"
    const Scope = "offline_access read_candidate read_contact read_user write_candidate write_contact"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://id.jobadder.com/connect/authorize?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&redirect_uri=" + RedirectUrl

    async function OAuthGetTokenDone()
    {
        props.IntegrationSettings.DatasourceSettings.AccessToken = ""
    }

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController="/api/jobadder/tokens" OnOAuthGetTokenDone={OAuthGetTokenDone} OnSetReady={props.OnSetReady}/>
}

DatasourceJobAdder.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceJobAdder